import { getOffset, getStyle, isHTMLElement } from '@flowio/browser-helpers';
import parseFloat from './parseFloat';

/**
 * Given coordinates relative to the viewport where an element should be
 * positioned, returns the coordinates adjusted to the element offset parent.
 */
function adjustToOffsetParent(element, position) {
  if (!isHTMLElement(element)) {
    return position;
  }

  var cssPosition = getStyle(element, 'position');
  var cssTop = getStyle(element, 'top');
  var cssLeft = getStyle(element, 'left');
  var offset = getOffset(element);
  var top;
  var left;

  if ((cssPosition === 'absolute' || cssPosition === 'fixed') && (cssTop === 'auto' || cssLeft === 'auto')) {
    top = element.offsetTop;
    left = element.offsetLeft;
  } else {
    top = parseFloat(cssTop, 0);
    left = parseFloat(cssLeft, 0);
  }

  return {
    top: position.top - offset.top + top,
    left: position.left - offset.left + left
  };
}

export default adjustToOffsetParent;